import React from 'react';
import { Section } from './Shared';
export function PainSection() {
  return <div className="bg-cream-dark border-y border-beige-muted/50 relative overflow-hidden" data-id="element-151">
      {/* Soft background element */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-sage-light/20 blur-[100px] rounded-full -z-10" data-id="element-152"></div>

      <Section className="max-w-4xl text-center !py-20" data-id="element-153">
        <h2 className="font-playfair text-3xl md:text-5xl text-charcoal font-medium leading-tight mb-6" data-id="element-154">
          No necesitás hacer actividades perfectas para estimular bien a tu bebé
        </h2>
        <p className="text-xl md:text-2xl text-charcoal-light font-medium max-w-2xl mx-auto leading-relaxed" data-id="element-155">
          Tu presencia, el juego y los pequeños momentos cotidianos también
          construyen desarrollo.
        </p>
      </Section>
    </div>;
}